import { render, staticRenderFns } from "./SolanAboutPure.vue?vue&type=template&id=f6f8b3a8&scoped=true&"
import script from "./SolanAboutPure.vue?vue&type=script&lang=ts&"
export * from "./SolanAboutPure.vue?vue&type=script&lang=ts&"
import style0 from "./SolanAboutPure.vue?vue&type=style&index=0&id=f6f8b3a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f8b3a8",
  null
  
)

export default component.exports